/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as t from "react";
import d from "prop-types";
import { useDir as l, getTabIndex as i, classNames as n } from "@progress/kendo-react-common";
const m = t.forwardRef(
  (e, s) => {
    const r = t.useRef(null), a = t.useRef(null);
    return t.useImperativeHandle(r, () => ({
      element: a.current,
      props: e
    })), t.useImperativeHandle(
      s,
      () => r.current
    ), /* @__PURE__ */ t.createElement(t.Fragment, null, e.rootItem ? /* @__PURE__ */ t.createElement(
      "ol",
      {
        id: e.id,
        ref: a,
        style: e.style,
        dir: l(a, e.dir),
        tabIndex: i(e.tabIndex, e.disabled),
        className: n(
          "k-breadcrumb-root-item-container",
          {
            "k-disabled": e.disabled
          },
          e.className
        )
      },
      e.children
    ) : /* @__PURE__ */ t.createElement(
      "ol",
      {
        id: e.id,
        ref: a,
        style: e.style,
        dir: l(a, e.dir),
        tabIndex: i(e.tabIndex, e.disabled),
        className: n(
          "k-breadcrumb-container !k-flex-wrap",
          {
            "k-disabled": e.disabled
          },
          e.className
        )
      },
      e.children
    ));
  }
), c = {
  id: d.string,
  className: d.string,
  children: d.element,
  tabIndex: d.number,
  style: d.object,
  dir: d.string,
  disabled: d.bool
};
m.displayName = "KendoReactBreadcrumbOrderedList";
m.propTypes = c;
export {
  m as BreadcrumbOrderedList
};
